import { useEffect, useRef } from 'react';
import { getFrameType, createAnimator } from '@entities/user/ui/UserAvatar';

export const useCardAnimation = (user, avatarFrame, cardRef) => {
  const animationRef = useRef(null);

  useEffect(() => {
    const frameType = getFrameType(user, avatarFrame);
    if (!frameType || !cardRef.current) return;

    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      cardRef.current.style.boxShadow = '';
      cardRef.current.style.borderColor = '';
    }

    const startAnimation = createAnimator(cardRef, animationRef);
    startAnimation(frameType);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [user, avatarFrame, cardRef]);

  return animationRef;
};